export const FILES_SCHEMA = `
CREATE TABLE IF NOT EXISTS files (
  id INTEGER PRIMARY KEY AUTOINCREMENT,
  rel_path TEXT NOT NULL,
  display_path TEXT NOT NULL,
  size INTEGER NOT NULL,
  mtime_ns INTEGER NOT NULL,
  mode INTEGER,
  ino TEXT,
  dev TEXT,
  is_symlink INTEGER NOT NULL DEFAULT 0,
  target TEXT,
  content_sha256 TEXT,
  service_file_hash TEXT,
  last_seen_ts INTEGER NOT NULL,
  hash_state TEXT NOT NULL,
  hash_owner TEXT,
  hash_lease_expires_at INTEGER,
  hash_started_at INTEGER,
  UNIQUE(rel_path)
);
CREATE INDEX IF NOT EXISTS idx_files_hash_state ON files(hash_state);
CREATE INDEX IF NOT EXISTS idx_files_content_sha ON files(content_sha256);
CREATE INDEX IF NOT EXISTS idx_files_service_hash ON files(service_file_hash);
`;

export const SNAPSHOTS_SCHEMA = `
CREATE TABLE IF NOT EXISTS snapshots (
  id INTEGER PRIMARY KEY AUTOINCREMENT,
  snapshot_hash TEXT NOT NULL,
  files_count INTEGER NOT NULL,
  total_size INTEGER NOT NULL,
  created_at INTEGER NOT NULL
);
`;
